export default class GameUtil {
  static resetSize(element) {
    element.setSize(element.displayWidth, element.displayHeight)
  }

  static getViewPercentage({ X = null, Y = null }, element) {
    let elementWidth = element.sys?.canvas.width || element.displayWidth || 0
    let elementHeight = element.sys?.canvas.height || element.displayHeight || 0

    return {
      X: X !== null && this.getPercentage(X, elementWidth),
      Y: Y !== null && this.getPercentage(Y, elementHeight),
    }
  }

  static getPercentage(percentaje, value) {
    return (percentaje * value) / 100
  }
}
